
import Vue from "vue"
/**
  * 返回vue组件dom
  * @param component	xxx.vue
  * @param props	自定义传递给组件的属性数据
  * @returns {any|VNode}
  */
export function returnVueComponentElement(targetCopm, name, props) {
    let popComponent = Vue.component(name, targetCopm)
    let mypop = new popComponent({ propsData: props }).$mount()
    let popEl = mypop.$el
    return popEl
}


// WEBPACK FOOTER //
// ./src/util/vueUtil.js